// Factual profile data for Dr. P. B. Boss based on publicly listed information at pbboss.com

export const profile = {
  name: "Dr. P. B. Boss",
  title: "Founder & Chairman",
  org: "Osaka Group",
  titles: [
    {
      role: "Founder & Chairman",
      org: "Osaka Group",
    },
    {
      role: "Honorary Tourism Commissioner",
      org: "India to the European Union",
    },
  ],
  mantras: ["Quality Relationship", "Quality Service", "Quality Life"],
  contact: {
    email: "pbboss@osakaair.com",
    location: "Angamaly, Kerala, India",
  },
  // Web-optimized portraits served locally from /public/images (originals were 6-19MB each)
  hero_portrait: "/images/hero-blue.jpg", // navy suit, blue tie — primary hero portrait
  main_portrait: "/images/pbboss-main.jpg",
  desk_portrait: "/images/ppg08788.jpg", // wide editorial band (16/8)
  lounge_portrait: "/images/ppg08899.jpg", // seated, reflective — "letter from the chairman"
  classic_portrait: "/images/classic.jpg",
  contact_image: "/images/ppg08874.jpg", // white kurta — warm & approachable
  banners: [
    "https://pbboss.com/wp-content/uploads/2023/01/banner-01.webp",
    "https://pbboss.com/wp-content/uploads/2023/01/banner-03.webp",
    "https://pbboss.com/wp-content/uploads/2023/01/banner-04.webp",
  ],
};

export const stats = [
  { value: "33+", label: "Years of Experience" },
  { value: "12", label: "Companies" },
  { value: "+3M", label: "Satisfied Clients" },
  { value: "250+", label: "Employees" },
];

export const bioShort =
  "An entrepreneur, philanthropist and visionary with three decades of leadership in the global travel and tourism industry. Founder and Chairman of the Osaka Group of Companies — a multi-vertical enterprise spanning travel, visa services, overseas education, technology, and real estate across India, the UK, Australia, Canada, the USA, the UAE and Singapore.";

export const bioParagraphs = [
  "Three decades in travel and tourism have shaped a leadership style anchored in passion, attentive listening, and a steady drive to improvise and improve. As Managing Director of the Osaka Group, the journey has been one of building enduring institutions and meaningful relationships, in equal measure.",
  "Technology stands at the heart of human progress — and at the heart of Osaka Group's vision. The mission is simple: incorporate tech-driven innovations that elevate quality of life and shape sustainable business models that outlive the founder.",
  "Family forms the foundation of every endeavour. Mrs. Bissy Boss, Director at Osaka Group of Companies, is partner and pillar in this journey. Daughter Ms. Lakshmi Boss serves at the Embassy of Costa Rica with her sights set on the Indian Foreign Service. Son Mr. Athul Boss serves as Director at Osaka Group of Companies — continuing the legacy.",
];

export const profilePhilosophy =
  "Pure, untainted thoughts are powerful — naturally rooted in truth, free of fragmentation and doubt. The greatest power we possess is the power of pure thinking. When we take full responsibility for everything we think, we improve the quality of our lives, the lives of those around us, and the wellbeing of the world.";

export const family = [
  {
    name: "Mrs. Bissy Boss",
    role: "Director, Osaka Group of Companies",
    note: "Companion and partner in life and business — a compassionate, courageous woman whose contribution is integral to both family and enterprise.",
    image: "/images/site/bissy-boss.jpg",
  },
  {
    name: "Ms. Lakshmi Boss",
    role: "Embassy of Costa Rica",
    note: "Post-graduate from Jindal Global University. Focused on a career in the Indian Foreign Service.",
    image: "/images/site/Untitled-2.webp",
  },
  {
    name: "Mr. Athul Boss",
    role: "Director, Osaka Group of Companies",
    note: "Continuing the family legacy of building a global, technology-led travel and education enterprise.",
    image: "/images/site/athul-boss.webp",
  },
];

export const timeline = [
  { year: "1993", event: "Osaka Air Travels established" },
  { year: "1997", event: "IATA approved agent" },
  { year: "1998", event: "Osaka Air Travels Pvt. Ltd. established" },
  {
    year: "1999",
    event: "Full Fledged Money Changers (FFMC) license from RBI",
  },
  {
    year: "2006",
    event: "Manpower Recruitment License from Ministry of External Affairs",
  },
  {
    year: "2008",
    event: "Osaka Bhavan — Jeeva Pranava Wellness Kendra office established",
  },
  { year: "2010", event: "Kerala Tour Mart India Pvt. Ltd. established" },
  { year: "2012", event: "Kochi branch opened at M. G. Road" },
  {
    year: "2018",
    event: "Global B2B portal OsakaConnect.com & Osaka Educare launched",
  },
  {
    year: "2019",
    event:
      "New Head Office at KSRTC Building Complex, Angamaly — Kerala's largest travel management office space",
  },
];

export const ventures = [
  {
    name: "Osaka Air Travels Pvt. Ltd.",
    role: "Managing Director",
    where: "Kochi, Kerala, India",
    blurb:
      "Premier travel agency offering ticketing, tour packages, foreign exchange and global travel solutions with an emphasis on exceptional customer service.",
  },
  {
    name: "Osaka Visa Facilitation & Global Visa Services",
    role: "Proprietor",
    where: "Kochi, Kerala, India",
    blurb:
      "Seamless visa processing, MEA/Embassy attestations and legal travel documentation for the USA, UK, Canada, Australia, New Zealand and other destinations.",
  },
  {
    name: "Kerala Tour Mart (India) Pvt. Ltd.",
    role: "Managing Director",
    where: "Kochi, Kerala, India",
    blurb:
      "Leading inbound, outbound and domestic tour operator. Customised itineraries for travellers worldwide, with medical tourism services.",
  },
  {
    name: "Osaka Educare",
    role: "Partner",
    where: "Kochi, Kerala, India",
    blurb:
      "Study-abroad consultancy supporting students pursuing higher education across 18 countries with end-to-end university and visa assistance.",
  },
  {
    name: "Osaka Connect Dot Com",
    role: "Managing Director",
    where: "Kochi · Bangalore · Delhi · Mumbai · Angamaly",
    blurb:
      "World's first travel hypermarket and travel super-app — 24 travel products on a single online platform.",
  },
  {
    name: "Osaka Connect Dot Com UK Ltd.",
    role: "Managing Director",
    where: "United Kingdom",
    blurb:
      "B2B, B2C and B2E travel services across the UK with a commitment to tailored solutions and customer satisfaction.",
  },
  {
    name: "Osaka Connect Australia Pty Ltd.",
    role: "Managing Director",
    where: "Australia",
    blurb:
      "Expanding the group's footprint with comprehensive corporate, business and personal travel solutions.",
  },
  {
    name: "Osaka Connect Canada Inc.",
    role: "Managing Director",
    where: "Canada",
    blurb:
      "Wide-ranging travel-related services with cutting-edge technology and a customer-centric approach.",
  },
  {
    name: "Osaka Connect USA Inc.",
    role: "Managing Director",
    where: "United States",
    blurb:
      "Global travel solutions tailored to B2B, B2C and B2E sectors across the United States.",
  },
  {
    name: "Osaka Connect Dot Com LLC FZ",
    role: "Managing Director",
    where: "United Arab Emirates",
    blurb:
      "Global travel solutions for B2B, B2C and B2E sectors across the UAE.",
  },
  {
    name: "Osaka Connectdotcom PTE. LTD.",
    role: "Managing Director",
    where: "Singapore",
    blurb:
      "Global travel solutions for B2B, B2C and B2E sectors across Singapore.",
  },
  {
    name: "Osaka Land Ventures",
    role: "Managing Partner",
    where: "Kerala, India",
    blurb: "Real estate development and investment activities in Kerala.",
  },
];

export const education = {
  institution: "Sree Sankara College, Kalady, Kerala",
  degree: "BSc Chemistry",
};

export const positions = [
  "Honorary Tourism Commissioner — India to the European Union",
  "Co-Chair — Tourism Panel, Confederation of Indian Industry (CII)",
  "Vice President — Kerala Sector, Indo Gulf & Middle East Chamber of Commerce (INMECC)",
  "Co-Chair — Kerala State, PHD Chamber of Commerce",
  "National Secretary — Indian Christian Movement (ICM)",
  "Former President — Kerala State Committee, IATA Agents Association of India",
  "Former Global Coordinator — Global Malayalee Council",
  "Former Development Committee Chairman — Margam Trust",
  "Former Vice President — Drisya Media Foundation",
];

export const memberships = [
  "IATA · TAAI · IAAI · IATO",
  "KTM · KCCI · KFEDA · ADETOI",
  "Angamaly Merchants' Association · Angamaly NRI Association",
  "SKAL International Club",
  "Rotary Club · Lions Club Cochin International Airport",
  "Golf Club Cochin International Airport",
  "The United Club · The Presidency Club · Rama Varma Club · ASA",
  "Pacific Asia Travel Association (PATA)",
  "Federation of Indian Chambers of Commerce and Industry (FICCI)",
  "Confederation of Indian Industry (CII)",
  "India – EU Trade Council",
  "PHD Chamber of Commerce and Industry (PHDCC)",
  "Indo-Japan Chamber of Commerce Kerala (INJAK)",
];

export const brands = [
  {
    name: "Osaka Educare",
    logo: "/images/site/osaka-educare.jpg",
  },
  {
    name: "Osaka Air Travels",
    logo: "/images/site/osaka-air-travels.jpg",
  },
  {
    name: "Osaka Air Travels Pvt Ltd",
    logo: "/images/site/osaka-airtravels-pvt-ltd.jpg",
  },
  {
    name: "Osaka Group",
    logo: "/images/site/osaka-group.jpg",
  },
  {
    name: "Osaka Connect",
    logo: "/images/site/osaka-connect.jpg",
  },
  {
    name: "Kerala Tour Mart",
    logo: "/images/site/kerala-tour-mart.jpg",
  },
];

export const awards = [
  {
    title: "Most Innovative Emerging Online Company Leadership Award",
    detail:
      "Travel & Tourism — Osaka Connect Dot Com. National Seminar on Individual Achievements & National Development (Atmanirbhar Bharat), New Delhi.",
    date: "31 May 2025",
  },
  {
    title: "Most Innovative Emerging Company Leadership Award",
    detail:
      "Travel & Tourism — Kerala Tour Mart India Pvt. Ltd. National Seminar (Atmanirbhar Bharat), New Delhi.",
    date: "31 May 2025",
  },
  {
    title: "Bharat Business Award 2025",
    detail:
      "Osaka Connect — world's first travel hypermarket and super-app. Organised by Taiikimedia, Holiday Inn, Mayur Vihar, Delhi.",
    date: "22 February 2025",
  },
  {
    title:
      "19th International Business Conclave & Award — Bangkok",
    detail:
      "Prominent Player in Travel and Tourism — Leadership Achievement Award for Osaka Connect.",
    date: "01 March 2025",
  },
  {
    title: "India's Hospitality Champions 2024 — Certificate of Excellence",
    detail:
      "Significant contribution to Osaka Connect — world's first global travel hypermarket. Mumbai.",
    date: "25 May 2024",
    image: "/images/honours/hospitality-champions-2024.jpg",
  },
  {
    title: "Best Seller Award — Singapore Airlines 2022-2023",
    detail:
      "Presented to Osaka Group by Singapore Airlines Southern Manager Imran Adnan.",
    date: "25 May 2023",
  },
  {
    title: "FICCI — Emerging Overseas Education Consultancy Award 2022",
    detail: "For Osaka Educare.",
    date: "10 December 2022",
  },
  {
    title: "Business Connect Award — Best Tour Organizer of 2022",
    detail:
      "Awarded to Kerala Tour Mart Pvt. Ltd. at the Indo-Global Entrepreneurship Conclave, Delhi.",
    date: "27 July 2022",
  },
  {
    title: "Global Business Achievements 2022",
    detail:
      "Most Trusted & Reliable Group of Companies in Travel & Tourism — Osaka Air Travels Pvt. Ltd., New Delhi.",
    date: "30 June 2022",
  },
  {
    title: "India's Emerging Company Award",
    detail: "Recognition for Osaka Group's emergence on the national stage.",
    date: "05 July 2022",
  },
  {
    title: "Certificate of Excellence — Industrial Excellence & Leadership",
    detail: "Recognising fastest-growing industrial excellence and business leadership.",
    date: "20 May 2022",
  },
  {
    title: "Best Tour Organizer of the Year 2022",
    detail: "Awarded to Kerala Tour Mart Pvt. Ltd.",
    date: "09 May 2022",
  },
  {
    title: "10 Most Trusted Overseas Education Consultants in India",
    detail: "Recognition for Osaka Educare.",
    date: "29 March 2022",
  },
  {
    title: "Women Summit and Awards 2022",
    detail: "Awarded to Mrs. Bissy Boss, Director, Osaka Group.",
    date: "25 March 2022",
  },
  {
    title: "National Education Excellence Award 2022",
    detail: "Awarded to Osaka Educare.",
    date: "25 May 2022",
  },
  {
    title: "National Excellence Award 2022",
    detail: "Awarded to Osaka Connect Dot Com Pvt. Ltd.",
    date: "25 March 2022",
  },
  {
    title: "TATA AIG Insurance — Top Seller, Kerala",
    detail: "Recognised as the top insurance seller in Kerala.",
    date: "01 February 2022",
  },
  {
    title: "World Signature Award 2019",
    detail:
      "Most Prominent Brand of the Year — Tour & Travel Kerala by APS Research & Median, Goa.",
    date: "18 January 2020",
  },
  {
    title: "Indian Glory Award 2020",
    detail: "Leading Overseas Education Consultant — WRB Group.",
    date: "10 January 2020",
  },
  {
    title: "Business Connect — Best Entrepreneur Award",
    detail: "Featured in Business Connect's 'Entrepreneur in Focus' 2019.",
    date: "15 November 2019",
  },
  {
    title: "International Gold Star Award 2019",
    detail:
      "Business Excellence at the 12th International Achievers Summit, Dubai.",
    date: "02 June 2019",
  },
  {
    title: "All India Achiever's Award 2019",
    detail:
      "Leading Emerging Company category — All-India Achiever's Foundation, New Delhi.",
    date: "19 May 2019",
  },
  {
    title: "Best Travel Company Excellence Award 2019",
    detail:
      "Awarded at the National Seminar — Individual Achievements and National Development, New Delhi.",
    date: "11 May 2019",
  },
  {
    title: "Asia's Quality & Entrepreneurship Award 2019",
    detail: "Awarded in New Delhi.",
    date: "27 April 2019",
  },
  {
    title: "Nehru Award 2018-2019",
    detail:
      "Excellence in Tour and Travel Management — Nehru Foundation Kerala State Committee.",
    date: "22 January 2019",
  },
  {
    title: "Mahashivarathri Puraskar 2019",
    detail: "Awarded in Kochi for socio-cultural contribution.",
    date: "22 March 2018",
  },
  {
    title: "International Achiever's Award 2018",
    detail:
      "Hospitality and Tourism — 11th International Achievers Summit, Bangkok.",
    date: "22 December 2018",
  },
  {
    title:
      "Mahatma Gandhi Excellence Award — Tourism & Travel Management",
    detail:
      "Awarded to Osaka Air Travels for contributions to socio-economic development.",
    date: "11 October 2018",
  },
  {
    title: "India Travel Awards South 2018",
    detail: "Best Business Travel Agency in South India, Bangalore.",
    date: "14 May 2018",
  },
];

export const news = [
  {
    title:
      "Dr. P. B. Boss Appointed as Honorary Tourism Commissioner — India to the European Union",
    date: "23 August 2025",
    image:
      "/images/site/g2026-09.jpg",
    outlets: [
      { name: "Google News", logo: "https://pbboss.com/wp-content/uploads/2025/09/GoogleNews.jpg", url: "https://news.google.com/search?q=Dr+P+B+Boss+Appointed+as+Honorary+Tourism+Commissioner+India+to+the+European+Union" },
      { name: "Yahoo", logo: "https://pbboss.com/wp-content/uploads/2025/09/Yahoo_news_logo.svg_.png", url: "https://search.yahoo.com/search?p=Dr+P+B+Boss+Appointed+as+Honorary+Tourism+Commissioner+India+to+the+European+Union" },
      { name: "ANI", logo: "https://pbboss.com/wp-content/uploads/2025/09/aninews.png", url: "https://www.aninews.in/news/business/dr-p-b-boss-appointed-as-honorary-tourism-commissioner-india-to-the-european-union20250821163412/" },
      { name: "PTI", logo: "https://pbboss.com/wp-content/uploads/2025/09/Press_Trust_of_India_logo.svg_.png", url: "https://www.ptinews.com/press-release/dr-p-b-boss-appointed-as-honorary-tourism-commissioner-%E2%80%92-india-to-the-european-union/2842360" },
      { name: "Tribune", logo: "https://pbboss.com/wp-content/uploads/2025/09/Tribune.png", url: "https://www.tribuneindia.com/news/business/dr-p-b-boss-appointed-as-honorary-tourism-commissioner-india-to-the-european-union/" },
      { name: "IANS", logo: "https://pbboss.com/wp-content/uploads/2025/09/logo.png", url: "https://ians.in/vmpl/dr-p-b-boss-appointed-as-honorary-tourism-commissioner-india-to-the-european-union" },
      { name: "Lokmat", logo: "https://pbboss.com/wp-content/uploads/2025/09/Lokmat-English.png", url: "https://www.lokmattimes.com/business/dr-p-b-boss-appointed-as-honorary-tourism-commissioner-india-to-the-european-union/" },
      { name: "The CEO Magazine", logo: "https://pbboss.com/wp-content/uploads/2025/09/theceo-magazine.png", url: "https://www.theceo.in/press-release/dr-p-b-boss-appointed-as-honorary-tourism-commissioner-india-to-the-european-union" },
      { name: "Dailyhunt", logo: "https://pbboss.com/wp-content/uploads/2025/09/daily-Hunt-Logo.png", url: "http://dhunt.in/11ygM1" },
      { name: "Latestly", logo: "https://pbboss.com/wp-content/uploads/2025/09/annotation-2019-01-08-142535.jpg", url: "https://www.latestly.com/agency-news/business-news-dr-p-b-boss-appointed-as-honorary-tourism-commissioner-india-to-the-european-union-7070640.html" },
    ],
  },
  {
    title:
      "ട്രാവൽ രംഗത്തെ യോദ്ധാവ് — Feature on Osaka Group, Mathrubhumi Yathra Travel Magazine",
    date: "05 January 2024",
    outlets: [],
  },
  {
    title:
      "Osaka Group receives Singapore Airlines Best Seller Award 2022-23 — ACTV News",
    date: "01 June 2023",
    outlets: [],
  },
  {
    title:
      "Best Seller Award for Singapore Airlines 2022-23 — Malayala Manorama",
    date: "01 June 2023",
    image:
      "/images/site/event-06.jpg",
    outlets: [],
  },
  {
    title: "Osaka Connect Global B2B Portal introduced at KTM 2018",
    date: "02 October 2018",
    outlets: [],
  },
  {
    title: "Osaka Educare Article — Indian Express",
    date: "23 February 2020",
    outlets: [],
  },
  {
    title:
      "Osaka Group Bengaluru Branch — Virtual Inauguration",
    date: "27 April 2021",
    outlets: [],
  },
  {
    title: "Osaka Group Delhi Branch — Virtual Inauguration",
    date: "01 December 2021",
    outlets: [],
  },
];

export const gallery = [
  "/images/site/g2026-11.jpg",
  "/images/site/g2026-00.jpg",
  "/images/site/g2026-01.jpg",
  "/images/site/g2026-02.jpg",
  "/images/site/g2026-03.jpg",
  "/images/site/g2026-04.jpg",
  "/images/site/g2026-05.jpg",
  "/images/site/g2026-06.jpg",
  "/images/site/g2026-07.jpg",
  "/images/site/g2026-08.jpg",
  "/images/site/g2026-09.jpg",
  "/images/site/g2026-10.jpg",
  "/images/ppg09511.jpg",
  "/images/site/event-00.jpg",
  "/images/ppg09854.jpg",
  "/images/site/event-13.jpg",
  "/images/ppg08899.jpg",
  "/images/site/event-06.jpg",
  "/images/ppg08874.jpg",
  "/images/site/event-09.jpg",
  "/images/ppg08843.jpg",
  "/images/site/event-14.jpg",
  "/images/ppg08788.jpg",
  "/images/site/event-15.jpg",
  "/images/ppg08918.jpg",
  "/images/site/event-08.jpg",
  "/images/pbboss-main.jpg",
  "/images/site/event-07.jpg",
  "/images/portrait-17.jpg",
  "/images/site/event-11.jpg",
  "/images/classic.jpg",
  "/images/site/event-03.jpg",
  "/images/site/event-04.jpg",
  "/images/site/event-05.jpg",
  "/images/site/banner-01.webp",
  "/images/site/banner-04.webp",
  "/images/site/banner-03.webp",
];


// ── Further honours & recognitions (sourced from the official achievements dossier) ──
export const furtherHonours = [
  {
    date: "22 Jun 2024",
    title: "Leadership Award for Excellence in Travel Hyper Market",
    detail:
      "18th International Business Conclave & Awards — theme 'New Emerging India: Atmanirbhar Bharat'. Bangkok, Thailand.",
  },
  {
    date: "27 May 2023",
    title: "International Business Tycoon — Global Excellence Award",
    detail:
      "UN75 India · FMBAF Global Excellence Awards, honouring dedication, spirit and professionalism in business.",
    image: "/images/honours/ibt-business-icon.jpg",
  },
  {
    date: "2022",
    title: "Kerala Kaumudi Excellence Award",
    detail:
      "For outstanding contributions and leadership within the travel and tourism industry.",
  },
  {
    date: "2022",
    title: "Personality Brand of Kerala — God's Own Awards",
    detail:
      "Recognising notable influence and achievement in business and service to the state of Kerala.",
  },
  {
    date: "2022",
    title: "IEDRA Global Asia Pacific Award",
    detail:
      "Recognised as a 'Leader in Innovative IT Technology'. Presented at Bangkok.",
    image: "/images/honours/iedra-2022.jpg",
  },
  {
    date: "May 2022",
    title: "Biz Arts Award",
    detail:
      "International Sree Sankara Dance & Music Festival, Kalady — for contributions across business and the arts.",
    image: "/images/honours/biz-arts.jpg",
  },
  {
    date: "29 Jun 2022",
    title: "Most Trusted & Reliable Group of Companies — Travel & Tourism, India",
    detail:
      "Topnotch Foundation, Hotel Shangri-La Eros, New Delhi.",
    image: "/images/honours/most-trusted-2022.jpg",
  },
  {
    date: "24 Apr 2021",
    title: "Best Travel Company of the Year",
    detail:
      "International Achievers Conference — National Seminar on Individual Achievements & National Development, New Delhi.",
    image: "/images/honours/best-travel-company.jpg",
  },
  {
    date: "12 Mar 2020",
    title: "Indian Achievers' Award for Business Excellence 2020",
    detail:
      "National Brand Impact Summit & Awards, New Delhi.",
    image: "/images/honours/indian-achievers-2020.jpg",
  },
  {
    date: "28 Feb 2020",
    title: "India's Signature Brands 2020 — Top Ranked Travel Company, South India",
    detail:
      "Holiday Inn Resort, Goa — graced by Sh. Suniel Shetty, with BARC as knowledge partner.",
    image: "/images/honours/signature-brands-2020.jpg",
  },
  {
    date: "15 Mar 2019",
    title: "Brand Leadership Award 2019",
    detail:
      "Brand Leadership Awards, Taj Malabar Resort & Spa, Cochin — endorsed by Dr. R. L. Bhatia.",
    image: "/images/honours/brand-leadership-2019.jpg",
  },
  {
    date: "May 2019",
    title: "National Winner — Travel & Tourism",
    detail:
      "71st State Conference, Angamaly — recognising outstanding contributions to the industry.",
  },
  {
    date: "Ongoing",
    title: "Paul Harris Fellow — The Rotary Foundation",
    detail:
      "Rotary International, for significant contributions to better understanding and goodwill among people worldwide.",
  },
  {
    date: "Civic",
    title: "Achievement Award — Angamaly Merchants' Association",
    detail:
      "In recognition of outstanding contributions and achievements in his field.",
    image: "/images/honours/achievement-angamaly.jpg",
  },
];

// ── Accreditations & certifications (corporate) ──
export const accreditations = [
  {
    name: "IATA Accreditation",
    detail:
      "International Air Transport Association — certified to promote and sell international air passenger transportation.",
  },
  {
    name: "ISO 9001:2008",
    detail: "Certified Quality Management System — Osaka Air Travels Pvt. Ltd.",
  },
  {
    name: "Startup India — DPIIT",
    detail:
      "Recognised by the Department for Promotion of Industry & Internal Trade (Cert. DIPP187172).",
  },
  {
    name: "Accredited Tour Operator",
    detail: "Government of Kerala, Department of Tourism — Kerala Tour Mart (India) Pvt. Ltd.",
  },
  {
    name: "Emigration Act Registration",
    detail:
      "Registered under Section 11 of the Emigration Act for overseas recruitment — Osaka Educare.",
  },
];

// ── Industry memberships & affiliations (corporate) ──
export const affiliations = [
  { name: "TAAI", detail: "Travel Agents Association of India — Member" },
  { name: "IATO", detail: "Indian Association of Tour Operators — Allied Member" },
  { name: "ADTOI", detail: "Association of Domestic Tour Operators of India — Active Member" },
  { name: "Kerala Travel Mart Society", detail: "Member of the Kerala Travel Mart" },
  { name: "SKÅL International", detail: "Member — SKÅL International Kochi" },
];

// ── Airline & industry partnerships / appreciations ──
export const partnerships = [
  { airline: "Singapore Airlines", note: "Top Agents Award — FY 2023-24", image: "/images/partners/singapore-airlines.jpg" },
  { airline: "Etihad Airways", note: "20 Years of Partnership", image: "/images/partners/etihad.jpg" },
  { airline: "Air India", note: "Valued Partner — 2023-24", image: "/images/partners/air-india.jpg" },
  { airline: "Vistara (TATA SIA)", note: "Contribution to Passenger Revenue Growth", image: "/images/partners/vistara.jpg" },
  { airline: "IndiGo", note: "Valued Support — 2021-22", image: "/images/partners/indigo.jpg" },
  { airline: "Oman Air", note: "Certificate of Appreciation — 2022", image: "/images/partners/oman-air.jpg" },
  { airline: "AirAsia", note: "High-Flying Partner — 2021-22", image: "/images/partners/airasia.jpg" },
  { airline: "Air Arabia", note: "Top Travel Agent Award — 2012", image: "/images/partners/air-arabia.jpg" },
  { airline: "Qatar Airways", note: "Signed Commemorative Bat", image: "/images/partners/qatar-airways.jpg" },
  { airline: "Akasa Air", note: "Certificate of Appreciation", image: "/images/partners/akasa.jpg" },
];
